import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import {
  useFormattedDepartmentOption,
  useFormattedEmpGroupOption,
  useFormattedEmployees,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const AnnouncementDetailModal = ({
  mode = "I",
  show = false,
  handleClose,
  data,
  companyCode
}) => {
  const employees = useFormattedEmployees({
    companyCode: data?.companyCode,
    locationCode: data?.locationCode,
  });

  const groups = useFormattedEmpGroupOption(companyCode);

  const departments = useFormattedDepartmentOption(companyCode);


  
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Announcement Details</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label htmlFor="field-1" className="form-label">
                Title
              </label>
              <span className="d-flex">{data?.title}</span>
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-3">
              <label htmlFor="field-2" className="form-label">
                Message
              </label>
              <span className="d-flex">{data?.message}</span>
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-3">
              <label htmlFor="field-2" className="form-label">
                Announcement Type
              </label>
              <span className="d-flex">
                {data?.type === "1"
                  ? "Employees"
                  : data?.type === "2"
                  ? "Departments"
                  : data?.type === "3"
                  ? "Groups"
                  : data?.type}
              </span>
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-3">
              <label htmlFor="field-2" className="form-label">
                Announced To
              </label>
              <span className="d-flex">
                {data?.type === "Employees" &&
                  data?.code
                    .map((code) => {
                      const emp = employees.find(
                        (e) => e.value === Number(code)
                      );
                      return emp ? emp.label : "";
                    })
                    .join(", ")}

                {data?.type === "Departments" &&
                  data?.code
                    .map((code) => {
                      const emp = departments.find((e) => e.value?.toString() === code);
                      return emp ? emp.label : "";
                    })
                    .join(", ")}

                {data?.type === "Groups" &&
                  data?.code
                    .map((code) => {
                      const emp = groups.find((e) => e.value === code);
                      return emp ? emp.label : "";
                    })
                    .join(", ")}
              </span>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

AnnouncementDetailModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.any,
  companyCode : PropTypes.any
};

export default AnnouncementDetailModal;
